module.exports = __webpack_public_path__ + "static/media/industry_hover2.26cd20af.svg";